import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  titleAndDescriptionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    marginBottom: "1.5rem",
  },
  titleAndCloseButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontFamily: "Sora",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "160%",
    letterSpacing: "0.15px",
  },

  closeBtn: {
    cursor: "pointer",
  },

  infosContainer: {
    padding: "16px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },

  wppContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },

  mailContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },

  descriptions: {
    color: "#191C1A",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    letterSpacing: "0.15px",
  },

  organizations: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "0.25rem",
    width: "100%",
    height: "100%",
    maxHeight: "20rem",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
}));

export { useStyles };
